import React from 'react';
import { BrowserRouter, Route, Redirect } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import { Container } from 'semantic-ui-react';

import Header from './Header';
import Footer from './Footer';
import LoginContainer from '../containers/LoginContainer';
import HomeContainer from '../containers/HomeContainer';
import ShopsContainer from '../containers/ShopsContainer';
import ShopContainer from '../containers/ShopContainer';
import ShopSocialNetworksContainer from '../containers/ShopSocialNetworksContainer';
import ShopSocialNetworkContainer from '../containers/ShopSocialNetworkContainer';
import UsersContainer from '../containers/UsersContainer';
import UserContainer from '../containers/UserContainer';
import RolesContainer from '../containers/RolesContainer';
import RoleContainer from '../containers/RoleContainer';
import CategoriesContainer from '../containers/CategoriesContainer';
import CategoryContainer from '../containers/CategoryContainer';
import ArticlesContainer from '../containers/ArticlesContainer';
import ArticleContainer from '../containers/ArticleContainer';
import ArticleLinksContainer from '../containers/ArticleLinksContainer';
import ArticleLinkContainer from '../containers/ArticleLinkContainer';
import GuidesContainer from '../containers/GuidesContainer';
import GuideContainer from '../containers/GuideContainer';
import EventsContainer from '../containers/EventsContainer';
import EventContainer from '../containers/EventContainer';
import OffersContainer from '../containers/OffersContainer';
import OfferContainer from '../containers/OfferContainer';
import EventLinksContainer from '../containers/EventLinksContainer';
import EventLinkContainer from '../containers/EventLinkContainer';
import ContactContainer from '../containers/ContactContainer';
import SubjectsContainer from '../containers/SubjectsContainer';
import SubjectContainer from '../containers/SubjectContainer';
import MediasContainer from '../containers/MediasContainer';
import NewsletterSubscribersContainer from '../containers/NewsletterSubscribersContainer';
import PassportFideliteSubscribersContainer from '../containers/PassportFideliteSubscribersContainer';
import PressReleasesContainer from '../containers/PressReleasesContainer';
import PressReleaseContainer from '../containers/PressReleaseContainer';
import PressKitContainer from '../containers/PressKitContainer';
import BlogContainer from '../containers/BlogContainer';
import AuthorsContainer from '../containers/AuthorsContainer';
import AuthorContainer from '../containers/AuthorContainer';
import AuthorDetailLinksContainer from '../containers/AuthorDetailLinksContainer';
import AuthorDetailLinkContainer from '../containers/AuthorDetailLinkContainer';
import HomeAppContainer from '../containers/HomeAppContainer';
import PracticalInfoContainer from '../containers/PracticalInfoContainer';
import OfficesContainer from '../containers/OfficesContainer';
import OfficeContainer from '../containers/OfficeContainer';
import OfficeSocialNetworksContainer from '../containers/OfficeSocialNetworksContainer';
import OfficeSocialNetworkContainer from '../containers/OfficeSocialNetworkContainer';
import PartnersContainer from '../containers/PartnersContainer';
import PartnerContainer from '../containers/PartnerContainer';
import AccessesContainer from '../containers/AccessesContainer';
import AccessContainer from '../containers/AccessContainer';
import ParkingsContainer from '../containers/ParkingsContainer';
import ParkingContainer from '../containers/ParkingContainer';
import ServicesContainer from '../containers/ServicesContainer';
import ServiceContainer from '../containers/ServiceContainer';
import PagesContainer from '../containers/PagesContainer';
import PageContainer from '../containers/PageContainer';
import QuestionsContainer from '../containers/QuestionsContainer';
import QuestionContainer from '../containers/QuestionContainer';
import ThePlaceContainer from '../containers/ThePlaceContainer';
import ThePlaceSlideContainer from '../containers/ThePlaceSlideContainer';
import ThePlaceSlidesContainer from '../containers/ThePlaceSlidesContainer';
import CoursesContainer from '../containers/CoursesContainer';
import CourseContainer from '../containers/CourseContainer';
import { AUTH_TOKEN } from '../constants';
import SlidesContainer from '../containers/SlidesContainer';
import SlideContainer from '../containers/SlideContainer';
import OnboardingsContainer from '../containers/OnboardingsContainer';
import OnboardingContainer from '../containers/OnboardingContainer';
import PocketGuideContainer from '../containers/PocketGuideContainer';
import FooterMenuContainer from '../containers/FooterMenuContainer';
import FooterSocialNetworksContainer from '../containers/FooterSocialNetworksContainer';
import FooterSocialNetworkContainer from '../containers/FooterSocialNetworkContainer';
import PageBuildersContainer from '../containers/PageBuildersContainer';
import PageBuilderContainer from '../containers/PageBuilderContainer';
import PassportFideliteContainer from '../containers/PassportFideliteContainer';
import PassportFideliteStatisticsContainer from '../containers/PassportFideliteStatisticsContainer';
import '../styles/dashboard.css';
import HeaderMenuContainer from '../containers/HeaderMenuContainer';
import HeaderCategoryContainer from '../containers/HeaderCategoryContainer';
import HeaderLinkContainer from '../containers/HeaderLinkContainer';
import FooterLinkContainer from '../containers/FooterLinkContainer';
import MainHomepageContainer from '../containers/MainHomepageContainer';
import HistorySlidesContainer from '../containers/HistorySlidesContainer';
import HistorySlideContainer from '../containers/HistorySlideContainer';
import GhdSocialNetworksContainer from '../containers/GhdSocialNetworksContainer';
import GhdSocialNetworkContainer from '../containers/GhdSocialNetworkContainer';
import PlanContainer from '../containers/PlanContainer';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem(AUTH_TOKEN) !== null ? (
        <Component {...props} />
      ) : (
        <Redirect to="/" />
      )
    }
  />
);

const App = (props) => {
  return (
    <BrowserRouter>
      <div>
        <Route path="/" component={Header} />
        <Container style={{ marginTop: '7em' }}>
          <Route exact path="/" component={LoginContainer} />
          <PrivateRoute exact path="/home" component={HomeContainer} />
          <PrivateRoute exact path="/shops" component={ShopsContainer} />
          <PrivateRoute
            exact
            path="/shops/:objId/social-networks/:snId"
            component={ShopSocialNetworkContainer}
          />
          <PrivateRoute
            exact
            path="/shops/:objId/social-networks"
            component={ShopSocialNetworksContainer}
          />
          <PrivateRoute exact path="/shops/:objId" component={ShopContainer} />
          <PrivateRoute exact path="/users" component={UsersContainer} />
          <PrivateRoute exact path="/users/:userId" component={UserContainer} />
          <PrivateRoute exact path="/roles" component={RolesContainer} />
          <PrivateRoute exact path="/roles/:objId" component={RoleContainer} />
          <PrivateRoute
            exact
            path="/categories"
            component={CategoriesContainer}
          />
          <PrivateRoute
            exact
            path="/categories/:objId"
            component={CategoryContainer}
          />
          <PrivateRoute exact path="/guides" component={GuidesContainer} />
          <PrivateRoute
            exact
            path="/guides/:objId"
            component={GuideContainer}
          />
          <PrivateRoute exact path="/offers" component={OffersContainer} />
          <PrivateRoute
            exact
            path="/offers/:objId"
            component={OfferContainer}
          />
          <PrivateRoute exact path="/events" component={EventsContainer} />
          <PrivateRoute
            exact
            path="/events/:objId/links/:detailId/:linkId"
            component={EventLinkContainer}
          />
          <PrivateRoute
            exact
            path="/events/:objId/links/:detailId"
            component={EventLinksContainer}
          />
          <PrivateRoute
            exact
            path="/events/:objId"
            component={EventContainer}
          />
          <PrivateRoute exact path="/contact" component={ContactContainer} />
          <PrivateRoute
            exact
            path="/passportfidelite"
            component={PassportFideliteContainer}
          />
          <PrivateRoute
            exact
            path="/passportfidelite/list"
            component={PassportFideliteSubscribersContainer}
          />
          <PrivateRoute
            exact
            path="/passportfidelite/stats"
            component={PassportFideliteStatisticsContainer}
          />
          <PrivateRoute
            exact
            path="/contact/subjects"
            component={SubjectsContainer}
          />
          <PrivateRoute
            exact
            path="/contact/subjects/:objId"
            component={SubjectContainer}
          />
          <PrivateRoute exact path="/medias" component={MediasContainer} />
          <PrivateRoute
            exact
            path="/newsletter-subscribers"
            component={NewsletterSubscribersContainer}
          />
          <PrivateRoute exact path="/blog" component={BlogContainer} />
          <PrivateRoute
            exact
            path="/blog/articles"
            component={ArticlesContainer}
          />
          <PrivateRoute
            exact
            path="/blog/articles/:objId"
            component={ArticleContainer}
          />
          <PrivateRoute
            exact
            path="/blog/articles/:objId/links/:detailId"
            component={ArticleLinksContainer}
          />
          <PrivateRoute
            exact
            path="/blog/articles/:objId/links/:detailId/:linkId"
            component={ArticleLinkContainer}
          />
          <PrivateRoute
            exact
            path="/blog/authors"
            component={AuthorsContainer}
          />
          <PrivateRoute
            exact
            path="/blog/authors/:objId"
            component={AuthorContainer}
          />
          <PrivateRoute
            exact
            path="/blog/authors/:objId/links/:detailId"
            component={AuthorDetailLinksContainer}
          />
          <PrivateRoute
            exact
            path="/blog/authors/:objId/links/:detailId/:linkId"
            component={AuthorDetailLinkContainer}
          />
          <PrivateRoute
            exact
            path="/press-releases"
            component={PressReleasesContainer}
          />
          <PrivateRoute
            exact
            path="/press-releases/:objId"
            component={PressReleaseContainer}
          />
          <PrivateRoute exact path="/press-kit" component={PressKitContainer} />
          <PrivateRoute exact path="/menu" component={HeaderMenuContainer} />
          <PrivateRoute
            exact
            path="/menu/categories/:objId"
            component={HeaderCategoryContainer}
          />
          <PrivateRoute
            exact
            path="/menu/links/:objId"
            component={HeaderLinkContainer}
          />
          <PrivateRoute exact path="/home-app" component={HomeAppContainer} />
          <PrivateRoute
            exact
            path="/practical-info"
            component={PracticalInfoContainer}
          />
          <PrivateRoute exact path="/offices" component={OfficesContainer} />
          <PrivateRoute
            exact
            path="/offices/:objId"
            component={OfficeContainer}
          />
          <PrivateRoute
            exact
            path="/offices/:objId/social-networks"
            component={OfficeSocialNetworksContainer}
          />
          <PrivateRoute
            exact
            path="/offices/:objId/social-networks/:snId"
            component={OfficeSocialNetworkContainer}
          />
          <PrivateRoute exact path="/partners" component={PartnersContainer} />
          <PrivateRoute
            exact
            path="/partners/:objId"
            component={PartnerContainer}
          />
          <PrivateRoute exact path="/accesses" component={AccessesContainer} />
          <PrivateRoute
            exact
            path="/accesses/:objId"
            component={AccessContainer}
          />
          <PrivateRoute exact path="/parkings" component={ParkingsContainer} />
          <PrivateRoute
            exact
            path="/parkings/:objId"
            component={ParkingContainer}
          />
          <PrivateRoute exact path="/services" component={ServicesContainer} />
          <PrivateRoute
            exact
            path="/services/:objId"
            component={ServiceContainer}
          />
          <PrivateRoute exact path="/pages" component={PagesContainer} />
          <PrivateRoute exact path="/pages/:objId" component={PageContainer} />
          <PrivateRoute
            exact
            path="/questions"
            component={QuestionsContainer}
          />
          <PrivateRoute
            exact
            path="/questions/:objId"
            component={QuestionContainer}
          />
          <PrivateRoute exact path="/the-place" component={ThePlaceContainer} />
          <PrivateRoute
            exact
            path="/the-place/:slideType"
            component={ThePlaceSlidesContainer}
          />
          <PrivateRoute
            exact
            path="/the-place/:slideType/:objId"
            component={ThePlaceSlideContainer}
          />
          <PrivateRoute exact path="/home-pwa" component={SlidesContainer} />
          <PrivateRoute
            exact
            path="/home-pwa/:objId"
            component={SlideContainer}
          />
          <PrivateRoute
            exact
            path="/onboarding"
            component={OnboardingsContainer}
          />
          <PrivateRoute
            exact
            path="/onboarding/:objId"
            component={OnboardingContainer}
          />
          <PrivateRoute
            exact
            path="/pocket-guide"
            component={PocketGuideContainer}
          />
          <PrivateRoute exact path="/courses" component={CoursesContainer} />
          <PrivateRoute
            exact
            path="/courses/:objId"
            component={CourseContainer}
          />
          <PrivateRoute exact path="/footer" component={FooterMenuContainer} />
          <PrivateRoute
            exact
            path="/footer/links/:objId"
            component={FooterLinkContainer}
          />
          <PrivateRoute
            exact
            path="/footer/:objId/social-networks"
            component={FooterSocialNetworksContainer}
          />
          <PrivateRoute
            exact
            path="/footer/:objId/social-networks/:snId"
            component={FooterSocialNetworkContainer}
          />
          <PrivateRoute
            exact
            path="/page-builders"
            component={PageBuildersContainer}
          />
          <PrivateRoute
            exact
            path="/page-builders/:objId"
            component={PageBuilderContainer}
          />
          <PrivateRoute
            exact
            path="/homepage"
            component={MainHomepageContainer}
          />
          <PrivateRoute
            exact
            path="/homepage/history"
            component={HistorySlidesContainer}
          />
          <PrivateRoute
            exact
            path="/homepage/history/:objId"
            component={HistorySlideContainer}
          />
          <PrivateRoute
            exact
            path="/social-networks"
            component={GhdSocialNetworksContainer}
          />
          <PrivateRoute
            exact
            path="/social-networks/:objId"
            component={GhdSocialNetworkContainer}
          />
          <PrivateRoute exact path="/plan" component={PlanContainer} />
        </Container>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js